/*
 * 保留小数点后几位 默认2
 * @methods getToFixed
 */

const getToFixed = function (value) {
  // 截取当前数据到小数点后两位
  if (!value) value = 0
  let realVal = parseFloat(Number(value).toFixed(2))

  return realVal
}
export default {
  getToFixed
}



// WEBPACK FOOTER //
// ./src/utils/filters.js